<template>
    <div class="circle-Loading">
        <fulfilling-bouncing-circle-spinner
            :animation-duration="2000"
            :size="80"
            color="#0080FC"
        />
        <span class="loading-wait">{{view.translations.label_loading_v5}}...</span>
    </div>
</template>

<script>
    import { FulfillingBouncingCircleSpinner } from 'epic-spinners'
    export default {
        name: 'lv5-circle-spinner',
        components: {
            'fulfilling-bouncing-circle-spinner': FulfillingBouncingCircleSpinner
        },
        props: ['view']
    }
</script>
<style scoped lang="scss">
    .circle-Loading {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: fixed!important;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 9999!important;
        background-color: white;
        .loading-wait{
            font-size: 2rem;
            font-family: "Muli", "Lato";
            line-height: 1.2;
            font-weight: normal;
            color: #434343;

            margin: 2rem 0 0 0;
        }
    }
</style>


// WEBPACK FOOTER //
// resources/office/js/components/login-v5/spinners/CircleSpinner.vue